"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var accessory_local_service_1 = require("../../../shared/service/accessory-local.service");
var accessory_amount_service_1 = require("../../../shared/service/accessory-amount.service");
var actions_1 = require("../../../core/actions");
var store_1 = require("@angular-redux/store");
var movement_1 = require("../../../shared/model/movement");
var common_1 = require("@angular/common");
var toast_service_1 = require("../../../shared/service/toast.service");
var AccessoryControlComponent = /** @class */ (function () {
    function AccessoryControlComponent(ngRedux, _accessoryLocalService, _accessoryAmountService, _location, _toastService) {
        this.ngRedux = ngRedux;
        this._accessoryLocalService = _accessoryLocalService;
        this._accessoryAmountService = _accessoryAmountService;
        this._location = _location;
        this._toastService = _toastService;
        this.pageNumber = 0;
        this.pageSize = 5;
        this.setUpObservers();
    }
    AccessoryControlComponent.prototype.ngOnInit = function () {
    };
    AccessoryControlComponent.prototype.ngOnDestroy = function () {
    };
    AccessoryControlComponent.prototype.saveAmounts = function (amounts) {
        var editedAmounts = this.ngRedux.getState().editedAmounts;
        this._accessoryAmountService.move(new movement_1.Movement(amounts, editedAmounts));
    };
    AccessoryControlComponent.prototype.cancel = function () {
        this.cleanState();
    };
    AccessoryControlComponent.prototype.findLocals = function (pageConfig) {
        if (pageConfig && pageConfig.localName) {
            this._accessoryLocalService
                .findByNameContains(pageConfig.localName, pageConfig.pageNumber, pageConfig.pageSize);
        }
        else {
            try {
                this._accessoryLocalService
                    .findLocals(pageConfig.pageNumber, pageConfig.pageSize);
            }
            catch (e) {
                this._accessoryLocalService
                    .findLocals(this.pageNumber, this.pageSize);
            }
        }
    };
    AccessoryControlComponent.prototype.findLocalAccessories = function (local) {
        this.selectedLocal = local;
        this._accessoryAmountService.findAccessoryAmount(this.selectedLocal);
    };
    AccessoryControlComponent.prototype.setUpObservers = function () {
        var _this = this;
        this._accessoryAmountService.move$
            .subscribe(function () {
            _this.cleanState();
        });
        this._accessoryAmountService.error$
            .subscribe(function (error) { return _this.showMessage(error); });
        this.setUpFindLocalAction();
        this.setUpFindAmountAction();
    };
    AccessoryControlComponent.prototype.setUpFindLocalAction = function () {
        var _this = this;
        this._accessoryLocalService.find$
            .filter(function (locals) { return locals instanceof Array; })
            .subscribe(function (locals) { return _this.locals = locals; });
    };
    AccessoryControlComponent.prototype.setUpFindAmountAction = function () {
        var _this = this;
        this._accessoryAmountService.find$
            .filter(function (accessories) { return accessories instanceof Map; })
            .subscribe(function (accessories) {
            _this.accessories = accessories;
        });
    };
    AccessoryControlComponent.prototype.cleanState = function () {
        this.ngRedux.dispatch({ type: actions_1.CLEAN_ACCESSORIES });
        this.selectedLocal = null;
        this.accessories = null;
    };
    AccessoryControlComponent.prototype.showMessage = function (message) {
        this._toastService.showMessage(message, 4000);
    };
    AccessoryControlComponent.ctorParameters = function () { return [{ type: store_1.NgRedux }, { type: accessory_local_service_1.AccessoryLocalService }, { type: accessory_amount_service_1.AccessoryAmountService }, { type: common_1.Location }, { type: toast_service_1.ToastService }]; };
    return AccessoryControlComponent;
}());
exports.AccessoryControlComponent = AccessoryControlComponent;
//# sourceMappingURL=accessory-control.component.js.map


// WEBPACK FOOTER //
// accessory-control.component.js